import React, { useState } from "react";
import { LocalShipping } from '@mui/icons-material';
import { Card, CardContent, Chip, Divider, Grid, Paper, Typography } from "@mui/material";
import { Root } from "../../Const/componentStyles";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import LoadingPacking from "./LoadingPackingTruck";
import LoadingPackingTruck from "./LoadingPackingTruck";
import LoadingPackingContainer from "./LoadingPackingContainer";
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import Inventory2Icon from '@mui/icons-material/Inventory2'
import { useSelector } from "react-redux";
import { RootState } from "../../Redux/store/ReduxStore";
import {
    MDBBtn,
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBCard,
    MDBCardBody,
    MDBInput,
} from 'mdb-react-ui-kit';

type LoadingIconsType = {
  [key: string]: JSX.Element;
};

const LoadingIcons: LoadingIconsType = {
    Truck:<LocalShippingIcon />,
    Container: <Inventory2Icon />
}

const LoadingMain:React.FC = () => {
    const user = useSelector((state:RootState)=>state.auth.user);
    const [showList,setShowList] = useState(false);
    const [selected,setSelected] = useState('');

    const categories = [
        {
            groupName: 'Loading',
            items: ["Truck", "Container"],
        },
    ];

    const handleSelect = (selected:string) => {
        setSelected(selected);
        setShowList(true);
    }
    
    const handleBack = () => {
        setShowList(false);
        setSelected('');
    }

    return(
        <div className="pt-3 position-relative">

            {!showList?
                <Grid container spacing={2}>
                    {categories.map((group, groupIndex) => (
                        <Grid item xs={12} key={groupIndex}>
                        <Root>
{/*                                 <Typography variant="h5" component="div"> */}
{/*                                     <Divider textAlign="left" */}
{/*                                         sx={{ */}
{/*                                             "&::before, &::after": { */}
{/*                                                 borderColor: "primary.main", */}
{/*                                             }, */}
{/*                                         }} */}
{/*                                     > */}
{/*                                         <Chip label={group.groupName} className="label-ui" variant="outlined"/> */}
{/*                                     </Divider> */}
{/*                                 </Typography> */}

                            <Typography variant="h5" component="div">
                                <Chip label={group.groupName} className="label-ui font-28 fw-bold mb-2 p-0 border-0" variant="outlined"/>
                            </Typography>
                            <MDBCard className="">
                                <MDBCardBody className="text-white p-3 p-md-5">
                                    <Grid container spacing={2} className={'fade-in'}>
                                        {group.items.map((category, categoryIndex) => (
                                            <Grid item xs={12} sm={6} md={4} lg={3} className="tile" key={categoryIndex}>
                                                <Card
                                                    onClick={() => handleSelect(category)}
                                                >
                                                <CardContent className="shadow"
                                                    sx={{ display: 'block', alignItems: 'center',cursor: 'pointer', }}
                                                >
                                                        <Typography className="text-center" variant="h6" component="div">
                                                            <span className="loading-icon text-theme">{LoadingIcons[category]}</span>
                                                            <p className="m-0">{category}</p>
                                                        </Typography>
                                                </CardContent>
                                                </Card>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </MDBCardBody>
                            </MDBCard>
                        </Root>
                </Grid>
            ))}
            </Grid>
            :
                <div>
                    <div className="d-flex align-items-center justify-content-between">
                        <label className="label-ui font-28 fw-bold mb-3 p-0 border-0">Loading</label>
                        <span className="mb-3">
                            <Chip
                                label="Loading List"
                                color='info'
                                onClick={handleBack}
                                variant="outlined"
                                className="btn-outline-primary"
                            />
                        </span>
                    </div>
                    {
                        selected === "Truck" && <LoadingPackingTruck />
                    }
                    {
                        selected === "Container" && <LoadingPackingContainer />
                    }
                </div>
            }
        </div>
    )
}

export default LoadingMain;



// Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries

// // Your web app's Firebase configuration
// // For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyB-iPqwANZovNPtgxpuuvSempO7kvvTvs8",
//   authDomain: "krishca-inventory.firebaseapp.com",
//   projectId: "krishca-inventory",
//   storageBucket: "krishca-inventory.appspot.com",
//   messagingSenderId: "914771547030",
//   appId: "1:914771547030:web:01c70e4c5ae7b4ccea43b7",
//   measurementId: "G-J90S4DL8GF"
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);